import React from 'react';
import { capitalize } from 'lodash';

import { Box, StyledCheckbox, TextBox } from 'src/kit';

export const Checkbox = ({ item: { label, checked, value }, setFilter, ...props }) => {
  return (
    <Box mb="20px" minHeight="14px">
      <StyledCheckbox
        onChange={() => {
          setFilter(value);
        }}
        checked={checked}
        color={'primary'}
        size={14}
        {...props}
      >
        <TextBox ml={10} color="textSecondary" fontSize={14}>
          {label[0] === label[0].toUpperCase() ? label : capitalize(label)}
        </TextBox>
      </StyledCheckbox>
    </Box>
  );
};
